import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, AfterViewChecked, EventEmitter, Output, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AddEditJobComponent } from './add-edit-job/add-edit-job.component';
import { NotificationService } from 'src/@core/services/notification.service';
import { ProgressBarService } from 'src/@core/services/progress-bar.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
  MatPaginator,
  MatSort,
  MatTableDataSource,
  PageEvent
} from '@angular/material';
import { BehaviorSubject, merge, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { fadeInUp400ms } from 'src/@core/animations/fade-in-up.animation';
import { stagger40ms } from 'src/@core/animations/stagger.animation';
import { ColumnVisibilityDialogComponent } from 'src/app/shared/components/column-visibility-dialog/column-visibility-dialog.component';
import { Search } from 'src/@core/interfaces/search';
import { fadeInRight400ms } from 'src/@core/animations/fade-in-right.animation';
import { JobService } from 'src/@core/services/job/job.service';
import { Job } from 'src/@core/interfaces/job/job.model';
import { AppService, CURRENT_USER } from 'src/@core/services/app.service';
import { Employer } from 'src/@core/interfaces/employer/employer.model';
import { AddEditEmploymentComponent } from '../../employment/employment/add-edit-employment/add-edit-employment.component';
import { entityTypes, permissions, roles } from 'src/app/shared/helpers/roles-permissions'
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { JobCategoryService } from 'src/@core/services/job/job-category.service';
import { ActivatedRoute, NavigationExtras, ParamMap, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from 'src/@core/services/local-storage.service';
import { AssignJobAdminComponent } from '../../employment/assign-job-admin/assign-job-admin.component';
import { STATUS } from 'src/app/shared/helpers/status';
import { LayoutService } from 'src/@core/services/theme/layout.service';
import moment from 'moment';
import Swal from 'sweetalert2';
// export let paginator: MatPaginator;

@Component({
  selector: 'hour4u-admin-job',
  templateUrl: './job.component.html',
  styleUrls: ['./job.component.scss'],
  animations: [
    fadeInUp400ms,
    stagger40ms,
    fadeInRight400ms
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'standard'
      } as MatFormFieldDefaultOptions
    }
  ]
})

export class JobComponent implements OnInit, AfterViewChecked, OnDestroy {
  term = '';
  isSearch: boolean = true;
  isEmployerLogin = this.appService.getIsEmployerLogin();
  dataSource: MatTableDataSource<Job>;
  dataChange: BehaviorSubject<any>;
  roles = roles;
  permissions = permissions;
  entityTypes = entityTypes;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  resultsLength = 0;

  title = 'Job';
  columns = [
    { columnDef: 'project_name', visible: true, label: 'Project name' },
    // { columnDef: 'total_connected_leads', visible: true, label: 'Connected leads' },
    { columnDef: 'total_leads', visible: true, label: 'Total leads' },
    { columnDef: 'campaign_workflow_status', visible: true, label: 'Campaign status' },
    { columnDef: 'total_pending_follow_ups', visible: true, label: 'Pending follow-ups' },
    { columnDef: 'total_call_duration', visible: true, label: 'Total call duration' },
    { columnDef: 'total_call_duration_today', visible: true, label: "Today's call duration" },
    { columnDef: 'created_at', visible: true, label: 'Created on' },
    { columnDef: 'action', visible: true, label: '' },
  ];
  displayedColumns = this.columns.map(x => x.columnDef);

  // employer: Employer = this.appService.getEmployer();
  profile = this.appService.getCurrentAccount();
  pageIndex = 1;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100];
  searchParams: Array<Search> = [];
  loginUserDetails: any = null;
  row: any;

  diameter = 40;
  color: string;
  mode = 'indeterminate';
  // @Output() dataRefresh = new EventEmitter();

  status = STATUS;
  selectedAgency: any = null;
  selectedCreatedOn: any = null;
  selectedCreatedBy: any = null;
  selectedExpiredBy: any = null;
  /** Campaign outreach workflow filter: '' | 'true' | 'false' */
  selectedWorkflowActive: string = '';
  showWorkflowFilterPanel = false;
  agenciesList: any[] = [];
  createdByList: any[] = [];
  sort_field: string = "";
  timeoutRef: ReturnType<typeof setTimeout>;
  searchProjectName: string = "";
  isLoading: boolean = false;
  pagination: any;
  @Output() pageChange = new EventEmitter<number>();
  currentRange: string = '';
  pageNumbers: Array<number | string> = [];
  editingProjectId: string | null = null;
  editingProjectName: string = '';
  originalProjectName: string = '';

  /** Sort field sent to the projects API (synced with ?sort=) */
  listSortField = 'created_at';

  /** Extra search filters (e.g. agency/date) merged into each list request */
  filterSearchParams: Search[] = [];

  private queryParamsSub: Subscription;

  constructor(private dialog: MatDialog,
    private service: JobService,
    private jobTypeService: JobTypeService,
    private router: Router,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private notify: NotificationService,
    private progress: ProgressBarService,
    private appService: AppService,
    private _localStorageService: LocalStorageService,
    private layoutService: LayoutService) { }

  ngOnInit() {
    this.dataChange = new BehaviorSubject(0);
    this.dataSource = new MatTableDataSource();

    // Set page navigator with icon
    this.layoutService.setPageNavigator([
      { label: 'Projects', icon: 'assets/cube.svg' }
    ]);

    this.applyEntityColumnVisibility();

    this.queryParamsSub = this.route.queryParamMap.subscribe(params => {
      this.applyQueryParams(params);
      this.loadProjects();
    });

    if (this.profile && this.profile.entity && this.profile.entity.id) {
      //this.getAssignedAgenciesAndCreatedByArray();
    }
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  private applyQueryParams(params: ParamMap): void {
    const pageRaw = params.get('page');
    if (pageRaw != null && pageRaw !== '') {
      const p = parseInt(pageRaw, 10);
      this.pageIndex = Number.isFinite(p) && p >= 1 ? p : 1;
    } else {
      this.pageIndex = 1;
    }

    const sizeRaw = params.get('pageSize');
    if (sizeRaw != null && sizeRaw !== '') {
      const s = parseInt(sizeRaw, 10);
      this.pageSize = this.pageSizeOptions.includes(s) ? s : 10;
    } else {
      this.pageSize = 10;
    }

    const sortRaw = params.get('sort');
    this.listSortField = sortRaw && sortRaw.trim() ? sortRaw.trim() : 'created_at';

    const qRaw = params.get('q');
    this.searchProjectName = qRaw != null ? qRaw : '';
  }

  private navigateListQuery(queryParams: Params): void {
    void this.router.navigate([], {
      relativeTo: this.route,
      queryParams,
      queryParamsHandling: 'merge'
    });
  }

  private applyEntityColumnVisibility(): void {
    if (!this.profile || !this.profile.entity) {
      return;
    }
    if (this.profile.entity.entityType == 'AGENCY') {
      this.columns = this.columns.map(x => {
        if (x.columnDef == 'assignedAgencies') {
          x.visible = false;
        }
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }
    if (this.profile.entity.entityType == 'ENTERPRISE') {
      this.columns = this.columns.map(x => {
        if (x.columnDef == 'assignedEnterprise') {
          x.visible = false;
        }
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }
    if (this.profile.entity.entityType == 'VENDOR') {
      this.columns = this.columns.map(x => {
        if (x.columnDef == 'employerName') {
          x.visible = false;
        }
        return x;
      });
      this.displayedColumns = this.columns.filter(x => x.visible).map(x => x.columnDef);
    }
  }

  private rebuildFilterSearchParams(): void {
    this.filterSearchParams = [];
    if (this.selectedAgency && this.selectedAgency.length) {
      this.selectedAgency.forEach(element => {
        this.filterSearchParams.push(new Search('entityIds', element));
      });
    }
    if (this.selectedCreatedBy && this.selectedCreatedBy.length) {
      this.selectedCreatedBy.forEach(element => {
        this.filterSearchParams.push(new Search('createdBy', element));
      });
    }
    if (this.selectedCreatedOn) {
      this.filterSearchParams.push(
        new Search('createdOn', moment(this.selectedCreatedOn).format('YYYY-MM-DD'))
      );
    }
    if (this.selectedWorkflowActive === 'true' || this.selectedWorkflowActive === 'false') {
      this.filterSearchParams.push(new Search('workflow_active', this.selectedWorkflowActive));
    }
  }

  toggleWorkflowFilter(event: MouseEvent): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.showWorkflowFilterPanel = !this.showWorkflowFilterPanel;
  }

  onWorkflowActiveFilterChange(value: string): void {
    this.selectedWorkflowActive = value || '';
    this.showWorkflowFilterPanel = false;
    this.filterBy();
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.showWorkflowFilterPanel) {
      this.showWorkflowFilterPanel = false;
    }
  }

  campaignWorkflowLabel(row: any): string {
    if (!row) {
      return 'Inactive';
    }
    if (row.campaign_workflow_active === true || row.campaign_workflow_status === 'active') {
      return 'Active';
    }
    return 'Inactive';
  }

  isCampaignWorkflowActive(row: any): boolean {
    return !!(row && (row.campaign_workflow_active === true || row.campaign_workflow_status === 'active'));
  }

  /** Reload list using current route-derived state (page, size, sort, q) and filter chips */
  loadProjects(): void {
    this.isLoading = true;
    this.pageNumbers = [];
    this.dataSource.data = Array(10).fill({} as Job);

    if (!(this.profile && this.profile.entity && this.profile.entity.id)) {
      this.isLoading = false;
      return;
    }

    const sortOrder = 'desc';
    this.searchParams = [];
    this.searchParams.push(new Search('title', this.searchProjectName || ''));
    if (this.filterSearchParams.length) {
      this.filterSearchParams.forEach(s => this.searchParams.push(s));
    }

    this.service!.getAllProjects(
      this.profile.entity.id,
      this.pageIndex,
      this.pageSize,
      this.listSortField,
      sortOrder,
      this.searchParams
    ).subscribe(
      (data: any) => {
        this.isLoading = false;
        this._localStorageService.setJobListPage(this.pageIndex);
        this._localStorageService.setTSearchParams(this.searchParams);
        this._localStorageService.setTSortParams(this.listSortField);
        if (data && data.items && data.pagination) {
          this.resultsLength = data.pagination.totalElements;
        }
        this.dataSource.data = data.items;
        this.pagination = data.pagination;
        this.pageNumbers = this.buildPageNumbers(this.pagination);
        this.updateRange();
        this.progress.hide();
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  searchByBillName() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      const q = (this.searchProjectName || '').trim();
      this.navigateListQuery({ page: 1, q: q || null });
    }, 700);
  }

  clearSearch() {
    this.searchProjectName = '';
    this.navigateListQuery({ page: 1, q: null });
  }

  getAssignedAgenciesAndCreatedByArray() {
    this.searchParams = [];
    const entityId = this.profile.entity.id;

    if (entityId) {
      this.service.getAssignedAgenciesAndCreatedByArray(entityId
      ).subscribe(data => {
        console.log(data)
        this.agenciesList = data.addedEntityIds;
        this.createdByList = data.createdBy;
        console.log(this.agenciesList)
        // this.resultsLength = data.totalElements;
      }, (error: any) => {
        this.notify.showMessage(error.error.message, 2000);
      });
    } else {
      console.warn('Entity ID is not available. Unable to fetch agencies.');
    }
  }

  reloadTable() {
    this.dataChange.next(1);
  }

  search(data?) {
    this.searchParams = [];
    if (data) {
      this.searchParams.push(new Search('title', data));
    }
    if (this.profile.entity.entityType == 'ENTERPRISE') {
      this.searchParams.push(new Search('employerId', JSON.parse(localStorage.getItem(CURRENT_USER)).entity.id))
    } else {
      this.searchParams.push(new Search('entityId', JSON.parse(localStorage.getItem(CURRENT_USER)).entity.id))
    }
    // this.searchParams.push(new Search('code', data));
    this.dataChange.next(1);
  }

  sortData(direction) {
    this.sort.active = 'createdOn';
    this.sort.direction = direction.value;
    this.sort.sortChange.next();
  }

  create(): void {
    // this.router.navigate(['/add-edit-project']);
    this.router.navigate(['/dashboard']);
    return;
    const data = {
      title: 'Create Job Template'
    };

    const dialogRef = this.dialog.open(AddEditJobComponent, {
      width: '100vw',
      height: '100vh',
      disableClose: true,
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.dataChange.next(result.id);
      }
    });
  }

  // clone(object: any): void {
  //   object.id = null;
  //   object.status = null;
  //   object.cloned = true;
  //   const data = {
  //     title: 'Clone Template',
  //     data: object
  //   };
  //   const navigationExtras: NavigationExtras = {
  //     state: { data: JSON.stringify(data) },
  //   };
  //   this.router.navigate(['add-edit-project'], navigationExtras);
  //   return;
  //   const dialogRef = this.dialog.open(AddEditJobComponent, {
  //     width: '700px',
  //     disableClose: true,
  //     data
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     this.dataChange.next(1);
  //   });
  // }

  // update(object: any): void {
  //   console.log(object)
  //   this.router.navigate(['/add-edit-job-template/' + object.id]);
  //   return;
  //   const data = {
  //     title: 'Modify Job',
  //     data: object
  //   };
  //   const dialogRef = this.dialog.open(AddEditJobComponent, {
  //     width: '700px',
  //     disableClose: true,
  //     data
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.dataChange.next(result.id);
  //     }
  //   });
  // }


  openDialogColumnOptions(): void {
    let col = this.columns;
    // if (this.profile.roles.indexOf(roles.EMPLOYER_STAFF) > -1 || this.profile.roles.indexOf(roles.EMPLOYER_ADMIN) > -1) {
    //   col = this.columns.filter(x => x.columnDef != 'employerId')
    // }

    const dialogRef = this.dialog.open(ColumnVisibilityDialogComponent, {
      width: '300px',
      data: col,
    });
    dialogRef.afterClosed().subscribe(
      result => {
        if (result) {
          this.displayedColumns = [];
          this.columns.forEach((value, key) => {
            if (value.visible) {
              this.displayedColumns.push(value.columnDef);
            }
          });
        }
      }
    );
  }

  ngOnDestroy(): void {
    // throw new Error("Method not implemented.");
    if (!this.router.url.includes('job/view')) {
      this._localStorageService.setJobListPage(0);
      this._localStorageService.setJobListPage(0);
      this._localStorageService.setTSearchParams([]);
      this._localStorageService.setTSortParams(null);
    }
    clearTimeout(this.timeoutRef);
    if (this.queryParamsSub) {
      this.queryParamsSub.unsubscribe();
    }

    // Clear page navigator when leaving this page
    this.layoutService.clearPageNavigator();
  }

  // // create Work Order
  // createWorkOrder(job: any) {
  //   const navigationExtras: NavigationExtras = {
  //     queryParams: { 'jobId': job.id, 'jobTypeId': job.jobTypeId, 'employerId': job.employerId }
  //   }
  //   this.router.navigate(['/enterprise-admin/create-work-order'], navigationExtras);
  // }

  viewJob(id) {
    // Find the project in the dataSource to get the project name
    // Note: dataSource contains project data with project_id and project_name, not Job type
    const project = this.dataSource.data.find((p: any) => p.project_id === id);
    if (project && (project as any).project_name) {
      // Set project name in layout service so toolbar can display it immediately
      this.layoutService.setProjectDetails({ project_name: (project as any).project_name });
    }
    this.router.navigateByUrl('/job/view-new-project/' + id);
  }

  // // Delete template
  // deleteTemplate(row) {
  //   this.service.deleteJobTemplate(row.id).subscribe(res => {
  //     this.dataChange.next(1);
  //   })
  // }

  setSearchPrams() {
    this.searchParams.forEach((search) => {
      if (search.column && search.content) {
        if (search.column == "title") {
          search.content = "";
          this.searchProjectName = search.content;
          this.isSearch = true;
        }
      }
    })
  }

  // // ASSIGN ADMIN DIALOG
  // assignAgency(data): void {
  //   // const employmentAdmin = new EmploymentAdministration();
  //   // employmentAdmin.employmentId = id;
  //   const dialogRef = this.dialog.open(AssignJobAdminComponent, {
  //     width: '600px',
  //     panelClass: 'assign-dialog',
  //     disableClose: true,
  //     data: data
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.dataRefresh.emit();
  //     }
  //   });
  // }

  dataRefresh() {
    // this.getAssignedAgenciesAndCreatedByArray();
    this.applyQueryParams(this.route.snapshot.queryParamMap);
    this.loadProjects();
  }

  filterBy() {
    this.rebuildFilterSearchParams();
    const currentPage = parseInt(this.route.snapshot.queryParamMap.get('page') || '1', 10) || 1;
    if (currentPage !== 1) {
      this.navigateListQuery({ page: 1 });
    } else {
      this.applyQueryParams(this.route.snapshot.queryParamMap);
      this.loadProjects();
    }
  }

  // approve/reject Project
  approveRejectProject(data, status) {
    console.log(data, status)
    this.service.updateProjectStatus(data.assignmentId, status).subscribe(res => {
      this.applyQueryParams(this.route.snapshot.queryParamMap);
      this.loadProjects();
      this.notify.showMessage('Project Status Updated Successfully!', 2000);
    }, ((err: any) => {
      this.notify.showMessage(err.error.message, 2000);
    }))
  }

  // // tab change
  // onTabChanged(event) {
  //   console.log(event)
  // }

  // onPageChange(event: PageEvent): void {
  //   this.pageIndex = event.pageIndex;
  //   this.pageSize = event.pageSize;
  //   this.searchParams = [];
  //   this.ngAfterViewInit();
  // }

  clearAgencySelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedAgency = null;
    this.filterBy();
  }
  clearCreatedBySelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedCreatedBy = null;
    this.filterBy();
  }
  clearCreatedOnSelection(eventData: Event): void {
    eventData.stopPropagation();
    this.selectedCreatedOn = null;
    this.filterBy();
  }

  goToSpecificSection(job, selectedTab) {
    console.log(job, selectedTab)
    this.router.navigateByUrl('/job/view/' + job.id + '/' + selectedTab);
  }

  onNext() {
    if (this.pagination && this.pagination.currentPageNum < this.pagination.totalPages) {
      this.navigateListQuery({ page: this.pagination.currentPageNum + 1 });
    }
  }

  onPageSelect(page: number | string) {
    if (!this.pagination || typeof page !== 'number' || page === this.pagination.currentPageNum) {
      return;
    }
    this.navigateListQuery({ page });
  }

  onPrev() {
    if (this.pagination && this.pagination.currentPageNum > 1) {
      this.navigateListQuery({ page: this.pagination.currentPageNum - 1 });
    }
  }

  buildPageNumbers(pagination: any): Array<number | string> {
    if (!pagination || !pagination.totalPages) {
      return [];
    }

    const totalPages = pagination.totalPages;
    const currentPage = pagination.currentPageNum;
    const pages: Array<number | string> = [];

    const addPage = (page: number | string) => {
      if (pages[pages.length - 1] !== page) {
        pages.push(page);
      }
    };

    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    addPage(1);

    if (currentPage > 3) {
      addPage('...');
    }

    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);

    for (let i = startPage; i <= endPage; i++) {
      addPage(i);
    }

    if (currentPage < totalPages - 2) {
      addPage('...');
    }

    addPage(totalPages);

    return pages;
  }

  updateRange() {
    if (this.pagination && this.pagination.currentPageNum && this.pagination.currentPageSize && this.pagination.totalElements) {
      const start = (this.pagination.currentPageNum - 1) * this.pagination.currentPageSize + 1;
      const end = Math.min(start + this.pagination.currentPageSize - 1, this.pagination.totalElements);
      this.currentRange = `${start} - ${end} of ${this.pagination.totalElements} records`;
    } else {
      this.currentRange = '0 - 0 of 0 records';  // Default value in case pagination is not valid
    }
  }

  onPageSizeChange(value: any) {
    const newSize = parseInt(value, 10);
    if (!Number.isFinite(newSize) || !this.pageSizeOptions.includes(newSize)) {
      return;
    }
    this.navigateListQuery({ page: 1, pageSize: newSize });
  }

  trackByPageNumber(index: number, _page: number | string): number {
    return index;
  }

  isEllipsis(page: number | string): boolean {
    return page === '...';
  }
  formatDate(createdAt: any): number | null {
    if (!createdAt) return null;

    const createdAtStr = createdAt.toString().trim(); // Ensure it's a string for processing

    if (createdAtStr.length === 14 && !isNaN(Number(createdAtStr))) {
      // ✅ Convert YYYYMMDDHHmmss to timestamp
      const year = parseInt(createdAtStr.substring(0, 4), 10);
      const month = parseInt(createdAtStr.substring(4, 6), 10) - 1; // Months are 0-based
      const day = parseInt(createdAtStr.substring(6, 8), 10);
      const hour = parseInt(createdAtStr.substring(8, 10), 10);
      const minute = parseInt(createdAtStr.substring(10, 12), 10);
      const second = parseInt(createdAtStr.substring(12, 14), 10);

      return new Date(year, month, day, hour, minute, second).getTime();
    }

    if (!isNaN(Number(createdAt))) {
      const createdAtNum = Number(createdAt);

      if (createdAtNum > 10000000000) {
        // ✅ If it's already in milliseconds, return as is
        return createdAtNum;
      } else if (createdAtNum > 1000000000) {
        // ✅ If it's in seconds, convert to milliseconds
        return createdAtNum * 1000;
      }
    }

    return null;
  }

  isWhatsappConnected(row: any): boolean {
    if (!row) return false;
    const status = row.whatsapp_status;
    if (typeof status === 'boolean') return status;
    if (typeof status === 'string') {
      const normalized = status.trim().toLowerCase();
      if (['connected', 'active', 'true', 'enabled', 'yes'].includes(normalized)) return true;
      if (['not_connected', 'disconnected', 'inactive', 'false', 'disabled', 'no', ''].includes(normalized)) return false;
    }
    // Fallback: treat presence of a connected phone number as connected
    return !!row.whatsapp_phone_number;
  }

  formatCallDuration(duration: any): string {
    if (!duration && duration !== 0) return '0';

    const durationNum = Number(duration);
    if (isNaN(durationNum) || durationNum < 0) return '0';

    // Convert seconds to hours and minutes
    const totalSeconds = durationNum;
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.round(totalSeconds % 60);

    // If less than 1 minute, show seconds
    if (totalSeconds < 60) {
      return `${seconds}s`;
    }

    if (hours === 0 && minutes === 0) {
      return '0m';
    } else if (hours === 0) {
      return `${minutes}m`;
    } else if (minutes === 0) {
      return `${hours}h`;
    } else {
      return `${hours}h ${minutes}m`;
    }
  }

  update(object: any): void {
    console.log(object)
    const data = {
      title: 'Edit Template',
      data: object
    };
    const navigationExtras: NavigationExtras = {
      state: { data: JSON.stringify(data) },
    };
    this.router.navigateByUrl('/job/view-new-project/' + object.project_id + '/setup-workflow');
  }

  deleteTemplate(row) {
    Swal.fire({
      title: '<img src="assets/trash-white.svg" style="width: 40px; height: 40px; margin: auto; margin-bottom: 20px;"> Are you sure?',
      html: '<p class="secondary">This action cannot be undone.</p>',
      showConfirmButton: true,
      confirmButtonText: "Delete",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      customClass: {
        popup: 'c-card-wrap',
        confirmButton: 'warning-btn',
        cancelButton: 'secondary-btn',
        title: 'secondary',
      },
      preConfirm: () => {
        let obj = {
          "entityId": row.entity_id,
          "projectId": row.project_id
        };
        return this.service.deleteProject(obj).toPromise();
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.notify.showMessage('Project deleted!', 3000);
        this.dataRefresh();
      } else {
        this.notify.showMessage('Unable to delete project!', 3000);
      }
    });
  }

  startEditingProjectName(row: any, event: Event): void {
    event.stopPropagation();
    this.editingProjectId = row.project_id;
    this.editingProjectName = row.project_name || '';
    this.originalProjectName = row.project_name || '';

    // Focus the input after view update
    setTimeout(() => {
      const input = document.querySelector('.project-name-input') as HTMLInputElement;
      const inputMobile = document.querySelector('.project-name-input-mobile') as HTMLInputElement;
      if (input) {
        input.focus();
        input.select();
      }
      if (inputMobile) {
        inputMobile.focus();
        inputMobile.select();
      }
    }, 0);
  }

  cancelEditingProjectName(event?: Event): void {
    if (event) {
      event.stopPropagation();
    }
    this.editingProjectId = null;
    this.editingProjectName = '';
    this.originalProjectName = '';
  }

  saveProjectName(row: any, event: Event): void {
    event.stopPropagation();
    if (!this.editingProjectName || this.editingProjectName.trim() === '') {
      this.notify.showMessage('Project name cannot be empty', 2000);
      return;
    }

    if (this.editingProjectName === this.originalProjectName) {
      this.cancelEditingProjectName();
      return;
    }

    const entityId = this.profile && this.profile.entity && this.profile.entity.id ? this.profile.entity.id : row.entity_id;

    this.service.updateProjectName(entityId, row.project_id, this.editingProjectName.trim()).subscribe(
      (response) => {
        this.notify.showMessage('Project name updated successfully!', 2000);
        row.project_name = this.editingProjectName.trim();
        this.cancelEditingProjectName();
        this.dataRefresh();
      },
      (error) => {
        this.notify.showMessage(error.error && error.error.message ? error.error.message : 'Failed to update project name', 2000);
        this.cancelEditingProjectName();
      }
    );
  }

  isEditingProject(projectId: string): boolean {
    return this.editingProjectId === projectId;
  }
}

